import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFileCardTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6.328 1.613-.594.887h4.532l-.594-.887a.26.26 0 0 0-.21-.113H6.535a.25.25 0 0 0-.209.113zM10.922.78 12.069 2.5h2.181c.416 0 .75.334.75.75s-.334.75-.75.75H14v9.5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5V4h-.25A.75.75 0 0 1 1 3.25c0-.416.334-.75.75-.75h2.181L5.078.778A1.76 1.76 0 0 1 6.534 0h2.929c.584 0 1.13.294 1.456.778zM3.5 4v9.5c0 .553.447 1 1 1h7c.553 0 1-.447 1-1V4zM6 6v6.5c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5m2.5 0v6.5c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5M11 6v6.5c0 .275-.225.5-.5.5a.5.5 0 0 1-.5-.5V6c0-.275.225-.5.5-.5s.5.225.5.5"
    />
  </svg>
);
export default SvgFileCardTrash;
